import { cva } from 'class-variance-authority';

export const variants = cva(
	['border border-solid inline-flex items-center justify-center max-w-fit whitespace-nowrap'],
	{
		variants: {
			variant: {
				white: [],
				primary: [],
				secondary: [],
				tertiary: [],
				success: [],
				danger: [],
				warning: [],
				dark: [],
				transparent: [],
			},
			size: {
				sm: ['leading-[14px] py-[2px] px-lg text-[12px] gap-sm'],
				md: ['leading-[16px] py-sm px-lg text-[14px] gap-md'],
				lg: ['leading-[16px] py-sm px-xl text-lg gap-md'],
			},
			outline: {
				true: [],
				false: ['border-transparent font-bold'],
			},
			rounded: {
				true: ['rounded-9xl'],
				false: ['rounded-sm'],
			},
		},
		compoundVariants: [
			{
				variant: 'white',
				outline: true,
				className: ['border-white text-white'],
			},
			{
				variant: 'primary',
				outline: true,
				className: ['border-primary-500 text-primary-500'],
			},
			{
				variant: 'secondary',
				outline: true,
				className: ['border-secondary-500 text-secondary-500'],
			},
			{
				variant: 'tertiary',
				outline: true,
				className: ['border-dark-500 text-white'],
			},
			{
				variant: 'success',
				outline: true,
				className: ['border-success-500 text-success-500'],
			},
			{
				variant: 'danger',
				outline: true,
				className: ['border-danger-500 text-danger-500'],
			},
			{
				variant: 'warning',
				outline: true,
				className: ['border-warning-500 text-warning-500'],
			},
			{
				variant: 'dark',
				outline: true,
				className: ['border-dark-950 text-dark-950'],
			},
			{
				variant: 'white',
				outline: false,
				className: ['bg-white !text-dark-900'],
			},
			{
				variant: 'primary',
				outline: false,
				className: ['bg-primary-500 !text-white'],
			},
			{
				variant: 'secondary',
				outline: false,
				className: ['bg-secondary-500 !text-white'],
			},
			{
				variant: 'tertiary',
				outline: false,
				className: ['bg-dark-500 !text-white'],
			},
			{
				variant: 'success',
				outline: false,
				className: ['bg-success-500 !text-white'],
			},
			{
				variant: 'danger',
				outline: false,
				className: ['bg-danger-500 !text-white'],
			},
			{
				variant: 'warning',
				outline: false,
				className: ['bg-warning-500 !text-white'],
			},
			{
				variant: 'dark',
				outline: false,
				className: ['bg-dark-950 !text-white'],
			},
		],
		defaultVariants: {
			variant: 'white',
			size: 'sm',
			outline: true,
			rounded: true,
		},
	},
);
